import(/* webpackMode: "eager", webpackExports: ["ArtworkDetail"] */ "/workspace/src/components/artworks/artwork-detail.tsx");
